"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _remarkSubSup = _interopRequireDefault(require("@uplight/remark-sub-sup"));

var _remarkShortcode = _interopRequireDefault(require("@uplight/remark-shortcode"));

var _MarkdownLinkRenderer = _interopRequireDefault(require("./MarkdownLinkRenderer"));

var _MarketplaceShortcodes = _interopRequireDefault(require("./MarketplaceShortcodes"));

var _fragmentWrapperRenderer = _interopRequireDefault(require("./fragmentWrapperRenderer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CustomReactMarkdown = function CustomReactMarkdown(_ref) {
  var className = _ref.className,
      linkActions = _ref.linkActions,
      linkMeta = _ref.linkMeta,
      source = _ref.source,
      renderers = _ref.renderers,
      tooltip = _ref.tooltip,
      noWrapper = _ref.noWrapper,
      styleFlag = _ref.styleFlag;
  var renderersCopy = renderers;

  if (noWrapper) {
    renderersCopy = _objectSpread(_objectSpread({}, _fragmentWrapperRenderer["default"]), renderers);
  }

  var raiseLinkActions = linkActions ? function (hooks) {
    ['*'].concat(_toConsumableArray(hooks)).filter(function (hook) {
      return linkActions[hook] instanceof Function;
    }).forEach(function (hook) {
      return linkActions[hook]();
    });
  } : null;
  var parsedSource = source;

  if (linkMeta && parsedSource) {
    var markdownLinkPattern = /\[([^[]+)\]\(([^(]+)\)/gi;

    var addLinkMetadata = function addLinkMetadata(_match, label, href) {
      var parsedHref = linkMeta.reduce(function (href, meta) {
        return href.includes("{".concat(meta, "}")) ? href : "".concat(href, "{").concat(meta, "}");
      }, href);
      return "[".concat(label, "](").concat(parsedHref, ")");
    };

    parsedSource = parsedSource.replace(markdownLinkPattern, addLinkMetadata);
  }

  return /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], {
    className: "custom-react-markdown".concat(className ? " ".concat(className) : ''),
    source: parsedSource,
    plugins: [_remarkShortcode["default"], _remarkSubSup["default"]],
    renderers: _objectSpread({
      link: function link(props) {
        return /*#__PURE__*/_react["default"].createElement(_MarkdownLinkRenderer["default"], _extends({}, props, {
          action: raiseLinkActions
        }));
      },
      shortcode: function shortcode(props) {
        return /*#__PURE__*/_react["default"].createElement(_MarketplaceShortcodes["default"], _extends({}, props, {
          styleFlag: styleFlag,
          tooltip: tooltip
        }));
      },
      sub: 'sub',
      sup: 'sup'
    }, renderersCopy)
  });
};

CustomReactMarkdown.propTypes = {
  className: _propTypes["default"].string,
  linkActions: _propTypes["default"].objectOf(_propTypes["default"].func),
  linkMeta: _propTypes["default"].arrayOf(_propTypes["default"].string),
  source: _propTypes["default"].string.isRequired,
  renderers: _propTypes["default"].shape({}),
  tooltip: _propTypes["default"].shape({}),
  noWrapper: _propTypes["default"].bool,
  styleFlag: _propTypes["default"].string
};
CustomReactMarkdown.defaultProps = {
  className: null,
  linkActions: null,
  linkMeta: null,
  renderers: {},
  tooltip: null,
  noWrapper: false,
  styleFlag: 'inline'
};
var _default = CustomReactMarkdown;
exports["default"] = _default;